import { render, staticRenderFns } from "./ImportDetail.vue?vue&type=template&id=185b15d2&scoped=true&"
import script from "./ImportDetail.vue?vue&type=script&lang=js&"
export * from "./ImportDetail.vue?vue&type=script&lang=js&"
import style0 from "./ImportDetail.vue?vue&type=style&index=0&id=185b15d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185b15d2",
  null
  
)

export default component.exports